module.exports = __webpack_public_path__ + "img/banner2.30bd1b77.png";